import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { OperatorsService } from '../../../services/http/operators/operators.service';
import { Operator } from '../../../services/http/operators/operators.interface';
import { AlertService } from '../../../services/alert/alert.service';
import { AlertType } from '../../../services/alert/alert.interface';
import { MunicipalityManagement } from '../../../services/http/municipalities/municipalities.interface';
import { MunicipalitiesService } from '../../../services/http/municipalities/municipalities.service';
import { Router } from '@angular/router';
import { LoaderService } from '../../../services/loader/loader.service';

@Component({
  selector: 'app-operators-list-page',
  standalone: true,
  imports: [CommonModule, FormsModule],
  templateUrl: './operators-list-page.component.html',
  styleUrl: './operators-list-page.component.scss'
})
export class OperatorsListPageComponent {
  filterRequest = {
    name: '',
    exceptions_profile: '',
    municipalities: ''
  }
  operators: Operator[] = [];
  municipalities: MunicipalityManagement[] = [];
  orderedField = '';
  orderedDirection = '';

  constructor(
    private readonly operatorsService: OperatorsService,
    private readonly alertService: AlertService,
    private readonly municipalitiesService: MunicipalitiesService,
    private readonly router: Router,
    private readonly loaderService: LoaderService
  ) {
    this.municipalitiesService.getMunicipalitiesManagement().subscribe((data) => {
      this.municipalities = data.municipalities;
    });
    this.filterChangedRequest();
  }

  onKeyPress(event: any) {
    if (event.keyCode === 13) {
      this.filterChangedRequest();
    }
  }

  filterChangedRequest() {
    if (this.filterRequest.name) {
      this.filterRequest.name = this.filterRequest.name.toUpperCase();
      this.filterRequest.name = this.filterRequest.name.replace(/ /g, '');
    }
    this.loaderService.show();
    this.operatorsService.getAllOperators().subscribe((operators) => {
      this.operators = operators;
      this.operators = this.operators.filter((operator: Operator) => {
        if (this.filterRequest.name !== '' && operator.name.toLowerCase().indexOf(this.filterRequest.name.toLocaleLowerCase()) === -1) {
          return false;
        }
        if (this.filterRequest.exceptions_profile !== '' && operator.exceptions_profile !== this.filterRequest.exceptions_profile) {
          return false;
        }
        if (this.filterRequest.municipalities !== '' && (operator.municipalities ? operator.municipalities.indexOf(this.filterRequest.municipalities) === -1 : false)) {
          return false;
        }
        return true;
      });
      if (this.operators.length === 0) {
        this.alertService.setAlert({
          message: $localize`:@@RequestList.noResults:No se han encontrado resultados`,
          type: AlertType.Error,
          dismissible: true,
          dismissOnTimeout: 5000
        });
      }
      this.loaderService.hide();
    });
  }

  clearFilters() {
    this.filterRequest = {
      name: '',
      exceptions_profile: '',
      municipalities: ''
    }
    this.filterChangedRequest();
  }

  orderTable(field: string) {
    if (this.orderedField === field) {
      this.orderedDirection = this.orderedDirection === 'asc' ? 'desc' : 'asc';
    } else {
      this.orderedField = field;
      this.orderedDirection = 'asc';
    }
    switch (this.orderedField) {
      case 'name':
        if (this.orderedDirection === 'asc') {
          this.operators.sort((a, b) => {
            return a.name.localeCompare(b.name);
          });
        } else {
          this.operators.sort((a, b) => {
            return b.name.localeCompare(a.name);
          });
        }
        break;
      case 'exceptions_profile':
        if (this.orderedDirection === 'asc') {
          this.operators.sort((a, b) => {
            return a.exceptions_profile.localeCompare(b.exceptions_profile);
          });
        } else {
          this.operators.sort((a, b) => {
            return b.exceptions_profile.localeCompare(a.exceptions_profile);
          });
        }
        break;
      case 'municipalities':
        if (this.orderedDirection === 'asc') {
          this.operators.sort((a, b) => {
            return a.municipalities ? a.municipalities[0].localeCompare(b.municipalities ? b.municipalities[0] : '') : -1;
          });
        } else {
          this.operators.sort((a, b) => {
            return b.municipalities ? b.municipalities[0].localeCompare(a.municipalities ? a.municipalities[0] : '') : -1;
          });
        }
    }
  }

  goToNew() {
    this.router.navigate(['operators/new']);
  }

  goToDetail(operator: Operator) {
    this.router.navigate(['/operators', operator.identifier]);
  }

  getLevelName(level: string) {
    return level === 'level1' ? $localize`:@@OperatorsListPage.level1:Nivel 1` : $localize`:@@OperatorsListPage.level2:Nivel 2`;
  }
}
